import { render } from "./Personal.vue?vue&type=template&id=b2fc7fb0&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"

import "./Personal.vue?vue&type=style&index=0&id=b2fc7fb0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2fc7fb0"

export default script